import Phaser from 'phaser';
import { CONFIG } from './config.js';
import { BootScene } from './scenes/BootScene.js';
import { PreloadScene } from './scenes/PreloadScene.js';
import { SplashScene } from './scenes/SplashScene.js';
import { MenuScene } from './scenes/MenuScene.js';
import { GameScene } from './scenes/GameScene.js';
import { HUDScene } from './scenes/HUDScene.js';
import { VictoryScene } from './scenes/VictoryScene.js';
import { GameOverScene } from './scenes/GameOverScene.js';

const config = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#1e1b4b',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: CONFIG.GAME_WIDTH,
    height: CONFIG.GAME_HEIGHT,
  },
  physics: {
    default: 'arcade',
    arcade: { gravity: { x: 0, y: 0 }, debug: false },
  },
  pixelArt: true,
  roundPixels: true,
  render: { antialias: false, roundPixels: true },
  input: { activePointers: 4 },
  scene: [
    BootScene,
    PreloadScene,
    SplashScene,
    MenuScene,
    GameScene,
    HUDScene,
    VictoryScene,
    GameOverScene,
  ],
};

new Phaser.Game(config);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
  });

  let reloading = false;
  const reloadOnce = (reason) => {
    if (reloading) return;
    reloading = true;
    showUpdateToast();
    setTimeout(() => {
      try {
        // Cache-busting reload — the toast is purely cosmetic; the SW already
        // serves the new bundle on the next request.
        window.location.reload();
      } catch (_) {
        window.location.href = window.location.href;
      }
    }, 1500);
  };

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'NEW_VERSION_AVAILABLE') {
      reloadOnce('message');
    }
  });
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    reloadOnce('controllerchange');
  });
}

function showUpdateToast() {
  if (document.getElementById('vs-update-toast')) return;
  const el = document.createElement('div');
  el.id = 'vs-update-toast';
  el.textContent = 'Nueva version disponible, recargando...';
  Object.assign(el.style, {
    position: 'fixed',
    top: '12px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '10px 16px',
    background: '#0f0d2c',
    color: '#fde047',
    fontFamily: '"Press Start 2P", monospace',
    fontSize: '10px',
    border: '2px solid #d946ef',
    borderRadius: '6px',
    zIndex: '9999',
    boxShadow: '0 4px 16px rgba(0,0,0,0.6)',
    pointerEvents: 'none',
  });
  document.body.appendChild(el);
}
